import { ISPFieldConfig } from '../../model';

/**
 * Map all configs
 *
 * @param fieldConfigs - fields config
 * @param mapFunction - map function
 */
export function mapConfigs<T>(
  fieldConfigs: ISPFieldConfig[],
  mapFunction: (field: ISPFieldConfig) => T,
): T[] {
  const map = (fields: ISPFieldConfig[]): T[] => {
    return fields
      .map(field => {
        if (field.fieldGroup) {
          return [mapFunction(field), ...map(field.fieldGroup)];
        } else {
          return [mapFunction(field)];
        }
      })
      .flat();
  };

  return map(fieldConfigs);
}
